// Builds the "Linked Menu Item" dropdown options for the Recipe editor.
//
// Regression context (GitHub issue #77): the admin "New Recipe" page populated
// the "Linked Menu Item" <Select> from recipeService.listIngredients() — i.e.
// with INGREDIENTS, not menu-item products. A recipe's linked product
// (recipe_headers.product_id) must reference a real product; sending an
// ingredient UUID made POST /api/v1/recipes fail at the
// recipe_headers.product_id → products foreign key (server error).
//
// The linked-item options must therefore be derived from the products list
// (menu items), never from the ingredients list.

export interface MenuItemOption {
  value: string;
  label: string;
}

/** A menu-item product. Only the fields used to build a dropdown option. */
export interface MenuItemProduct {
  id: string;
  name: string;
}

/** Sentinel option allowing a recipe to be created without a linked product. */
export const NO_LINKED_ITEM: MenuItemOption = { value: '', label: 'No linked item' };

/**
 * Map menu-item products to <Select> options, prefixed with the
 * "No linked item" sentinel. Products without an id are skipped so a recipe
 * can never be linked to an option that the API would reject.
 */
export function buildMenuItemOptions(products: MenuItemProduct[]): MenuItemOption[] {
  return [
    NO_LINKED_ITEM,
    ...products
      .filter((p) => typeof p.id === 'string' && p.id.length > 0)
      .map((p) => ({ value: p.id, label: p.name })),
  ];
}
